// extracted by mini-css-extract-plugin
module.exports = {"anchor":"popover-hover_anchor__w3UO4"};